export class KOSubscriptionTracker {
    private subscriptions: Array<KnockoutSubscription> = [];

    subscribe<T>(observables: KnockoutSubscribable<T> | KnockoutSubscribable<T>[], listener: (val: T) => void) {
        if (Array.isArray(observables)) {
            observables.forEach((obs: KnockoutSubscribable<T>) => {
                this.subscribe(obs, listener);
            })
        } else {
            let subscription = observables.subscribe(listener);
            this.subscriptions.push(subscription);
        }
    }

    unsuscribeAll() {
        this.subscriptions.forEach((subscription: KnockoutSubscription) => {
            subscription.dispose();
        });
    }

    subscribeChanged<T>(obs: KnockoutObservable<T>, listener: (newValue: T, oldValue: T) => void) {
        let subscription = (obs as any).subscribeChanged(listener);
        this.subscriptions.push(subscription);
    }
}
